<template>
  <f7-page name="asset-edit" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('AssetInfo') }}</f7-nav-title>
      <f7-nav-right>
        <label :for="inputSubmitId" class="link icon-only">
          <i class="icon f7-icons">checkmark_alt</i>
        </label>
      </f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading || isLoadingSSP || isLoadingSave" infinite color="green" class="progressbar-top"></f7-progressbar>

    <f7-list v-if="isLoading" media-list class="skeleton-text skeleton-effect-wave" key="assetEditSkeleton">
      <f7-list-item
          v-for="n in 4"
          :key="n"
          title="Title"
          subtitle="Subtitle"
      >
        <template #media>
          <f7-skeleton-block
              style="width: 40px; height: 40px; border-radius: 50%"
          ></f7-skeleton-block>
        </template>
      </f7-list-item>
    </f7-list>

    <form v-else action="" @submit.prevent="onSubmit">
      <input type="submit" :id="inputSubmitId" hidden >
      <!--:class="{'disabled': !IS_ROOT}"-->
      <f7-block-title>{{ $t('ServiceDetails') }}</f7-block-title>
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="IMEI"
            required
            validate
            validate-on-blur
            :label="$t('IMEI')"
            :placeholder="$t('IMEI')"
            :class="{'disabled': !IS_ROOT}"
            v-model:value="IMEI"

        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="AltIMEI"
            :label="$t('AltIMEI')"
            :placeholder="$t('AltIMEI')"
            :class="{'disabled': !IS_ROOT}"
            v-model:value="AltIMEI"

        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="SimNo"
            :label="$t('SimNo')"
            :placeholder="$t('SimNo')"
            :class="{'disabled': !IS_ROOT }"
            v-model:value="SimNo"

        >
          <template #media>
            <f7-icon icon="f7-icons icon-other-imei text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Customer"
            :label="$t('Customer')"
            :placeholder="$t('Customer')"
            class="disabled"
            v-model:value="Customer"

        >
          <template #media>
            <f7-icon icon="f7-icons icon-customer-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Product')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyProductList'+keyProductList"
            :class="{'disabled': !IS_ROOT || isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="ProductList" v-model="ProductCode">
            <option
                v-for="product in ProductList"
                :key="product.Code"
                :value="product.Code"
            >{{product.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('Solution')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keySolutionTypeList'+keySolutionTypeList"
            :class="{'disabled': !IS_ROOT || isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="SolutionList" v-model="SolutionCode">
            <option
                v-for="solution in SolutionTypeList"
                :key="solution.Code"
                :value="solution.Code"
            >{{solution.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('ServicePlan')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyServicePlan'+keyServicePlanList"
            :class="{'disabled': !IS_ROOT || isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons text-color-lightgray"></f7-icon>
          </template>
          <select name="ServicePlanList" v-model="ServicePlanCode">
            <option
                v-for="service in ServicePlanList"
                :key="service.Code"
                :value="service.Code"
            >{{service.Name}}</option>
          </select>
        </f7-list-item>
        <f7-list-item
            class="item-input custom-smart-select-wrapper"
            :title="$t('AssetType')"
            smart-select
            :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
            :key="'keyAssetType'+keyServicePlanList"
            :class="{'disabled': isLoadingSSP}"
        >
          <template #media>
            <f7-icon slot="media" :icon="`f7-icons text-color-lightgray icon-${ assetTypeIcon }`"></f7-icon>
          </template>
          <select name="AssetTypeList" v-model="AssetTypeCode">
            <option
                v-for="assetType in AssetTypeList"
                :key="assetType.code"
                :value="assetType.code"
                :data-option-icon="`f7-icons text-color-lightgray icon-${ assetType.icon }`"
            >{{assetType.name}}</option>
          </select>
        </f7-list-item>
        <f7-list-input
            :label="$t('ActivationDate')"
            type="datepicker"
            :placeholder="$t('ActivationDate')"
            readonly
            :calendar-params="{ dateFormat: 'dd/mm/yyyy', closeOnSelect: true }"
            v-model:value="ActivateDate"
            class="disabled"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            :label="$t('SuspensionDate')"
            type="datepicker"
            :placeholder="$t('SuspensionDate')"
            readonly
            :calendar-params="{ dateFormat: 'dd/mm/yyyy', closeOnSelect: true }"
            v-model:value="SuspendDate"
        >
          <template #media>
            <f7-icon slot="media" icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-item
            checkbox
            :title="$t('AutoSuspend')"
            name="checkbox-AutoSuspend"
            v-model:checked="AutoSuspend"
            class="bigger-media"
            color="green">
        </f7-list-item>

      </f7-list>

      <f7-block-title>{{ $t('AssetDetails') }}</f7-block-title>
      <f7-list class="no-margin-top no-hairline-bottom">
        <f7-list-input
            type="text"
            name="Name"
            :label="$t('Name')"
            :placeholder="$t('Name')"
            v-model:value="Name"
            required
            validate
        >
          <template #media>
            <f7-icon icon="f7-icons icon-assets text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Registration"
            :label="$t('Registration')"
            :placeholder="$t('Registration')"
            v-model:value="Registration"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="VinNumber"
            :label="$t('VinNumber')"
            :placeholder="$t('VinNumber')"
            v-model:value="VinNumber"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-number text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Make"
            :label="$t('Make')"
            :placeholder="$t('Make')"
            v-model:value="Make"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Model"
            :label="$t('Model')"
            :placeholder="$t('Model')"
            v-model:value="Model"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-details text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="text"
            name="Color"
            :label="$t('Color')"
            :placeholder="$t('Color')"
            v-model:value="Color"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-color text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
          type="tel"
          name="Year"
          :label="$t('Year')"
          :placeholder="$t('Year')"
          validate
          validate-on-blur
          pattern="[0-9]*"
          :error-message="$t('OnlyNumbers')"
          v-model:value="Year"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-year text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="tel"
            name="InitMileage"
            :label="$t('InitialMileage')"
            :placeholder="$t('InitialMileage')"
            validate
            validate-on-blur
            pattern="[-0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="InitMileage"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-live-distance text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="tel"
            name="InitRuntime"
            :label="$t('InitialRuntime')"
            :placeholder="$t('InitialRuntime')"
            validate
            validate-on-blur
            pattern="[-0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="InitRuntime"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-hours text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
        <f7-list-input
            type="tel"
            name="FuelEconomy"
            :label="$t('FuelEconomy')"
            :placeholder="$t('FuelEconomy')"
            validate
            validate-on-blur
            pattern="[.0-9]*"
            :error-message="$t('OnlyNumbers')"
            v-model:value="FuelEconomy"
        >
          <template #media>
            <f7-icon icon="f7-icons icon-live-fuel text-color-lightgray"></f7-icon>
          </template>
        </f7-list-input>
      </f7-list>

      <f7-block-title>{{ $t('InstallationDetails') }}</f7-block-title>
      <div class="list no-margin-top no-hairline-bottom">
        <ul class="row no-gap">
          <f7-list-input
              type="text"
              name="InstallLocation"
              :label="$t('InstallLocation')"
              :placeholder="$t('DeviceLocationInCar')"
              class="col-100"
              v-model:value="InstallLocation"
          >
            <template #media>
              <f7-icon icon="f7-icons icon-details text-color-lightgray"></f7-icon>
            </template>
          </f7-list-input>
          <f7-list-item
              v-if="isInput1Showed"
              class="item-input custom-smart-select-wrapper col-100"
              :title="input1NameLabel"
              smart-select
              :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
              :key="'keyInput1Name'+keyInputNamesList"
              :class="{'disabled': isLoadingSSP}"
          >
            <template #media>
              <f7-icon slot="media" :icon="`f7-icons text-color-lightgray icon-${ input1Icon }`"></f7-icon>
            </template>
            <select name="Input1Name" v-model="Input1Name">
              <option
                  v-for="inputType in InputsTypeList"
                  :key="inputType.code"
                  :value="inputType.code"
                  :data-option-icon="`f7-icons text-color-lightgray icon-${ inputType.icon }`"
              >{{inputType.name}}</option>
            </select>
          </f7-list-item>
          <f7-list-item
              v-if="isInput2Showed"
              class="item-input custom-smart-select-wrapper col-100"
              :title="input2NameLabel"
              smart-select
              :smart-select-params="{openIn: 'popup', searchbar: true, closeOnSelect: true, formColorTheme: 'green' }"
              :key="'keyInput2Name'+keyInputNamesList"
              :class="{'disabled': isLoadingSSP}"
          >
            <template #media>
              <f7-icon slot="media" :icon="`f7-icons text-color-lightgray icon-${ input2Icon }`"></f7-icon>
            </template>
            <select name="Input2Name" v-model="Input2Name">
              <option
                  v-for="inputType in InputsTypeList"
                  :key="inputType.code"
                  :value="inputType.code"
                  :data-option-icon="`f7-icons text-color-lightgray icon-${ inputType.icon }`"
              >{{inputType.name}}</option>
            </select>
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('RemoteImmobilise')"
              name="checkbox-fitmentoption"
              v-model:checked="RemoteImmobilise"
              value="1"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('AlarmIntegration')"
              name="checkbox-fitmentoption"
              v-model:checked="AlarmIntegration"
              value="2"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('SOSButton')"
              name="checkbox-fitmentoption"
              v-model:checked="SOSButton"
              value="4"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('EngineTheft')"
              name="checkbox-fitmentoption"
              v-model:checked="EngineTheft"
              value="32"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('Siren')"
              name="checkbox-fitmentoption"
              v-model:checked="Siren"
              value="64"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('RemoteDoor')"
              name="checkbox-fitmentoption"
              v-model:checked="RemoteDoor"
              value="512"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('DriverIDs')"
              name="checkbox-fitmentoption"
              v-model:checked="DriverIDs"
              value="2048"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('FittedAfterIsolator')"
              name="checkbox-fitmentoption"
              v-model:checked="FittedAfterIsolator"
              value="16"
              class="col-50"
              color="green">
          </f7-list-item>
          <f7-list-item
              checkbox
              :title="$t('NotConnectedToConstantPower')"
              name="checkbox-fitmentoption"
              v-model:checked="NotConnectedToIgnition"
              value="8"
              class="col-100"
              color="green">
          </f7-list-item>
        </ul>
      </div>

    </form>
  </f7-page>
</template>

<script>
import { QTAPI } from "../../services/qt-api";
import { mapGetters } from "vuex";
import { getAssetTypes, getAssetTypeIcon, SortArrayByObjProps, dateFormat, fixDateFormat, getInputsTypes, getInputTypeIcon, FitmentOptionsEnum, ProductFeaturesEnum } from "../../js/helpers"
import moment from "moment-mini";
import { f7 } from "framework7-vue";
import $$ from "dom7";

export default {
  name: "asset-edit",
  props: {
    f7router: Object,
    f7route: Object,

    assetData: { type: Object, default: ()=> { return {} } },
  },
  data() {
    return {
      inputSubmitId: f7.utils.id(),
      isLoading: false,
      isLoadingSSP: false,
      isLoadingSave: false,
      keyProductList: 1,
      keyServicePlanList: 1,
      keySolutionTypeList: 1,
      keyAssetTypeList: 1,
      keyInputNamesList: 1,

      ProductList: [],
      SolutionTypeList: [],
      ServicePlanList: [],
      AssetTypeList: [],
      InputsTypeList: getInputsTypes(),

      Id: this.assetData.ID,
      IMEI: this.assetData.IMEI,
      AltIMEI: this.assetData.IMEI2,
      SimNo: this.assetData.SimNO,
      ProductCode: null,
      AssetTypeCode: this.assetData.AssetType,
      Customer: this.assetData.Owner,
      CustomerCode: this.assetData.CustomerCode,
      SolutionCode: null,
      ServicePlanCode: null,
      AutoSuspend: +this.assetData.IsAutoSuspend == 1,
      ActivateDate: !this.assetData.ActiveDate ? null : [dateFormat(fixDateFormat(this.assetData.ActiveDate,  'MM/DD/YYYY', 'DD/MM/YYYY HH:mm:ss'))],
      SuspendDate: !this.assetData.SuspendDate ? null : [dateFormat(fixDateFormat(this.assetData.SuspendDate,  'MM/DD/YYYY', 'DD/MM/YYYY HH:mm:ss'))],
      Name: this.assetData.Name,
      Make: null,
      Model: null,
      Color: null,
      Year: null,
      Registration: null,
      VinNumber: null,
      InitMileage: null,
      InitRuntime: null,
      FuelEconomy: null,
      InstallLocation: null,
      RemoteImmobilise: false,
      AlarmIntegration: false,
      SOSButton: false,
      EngineTheft: false,
      Siren: false,
      RemoteDoor: false,
      DriverIDs: false,
      FittedAfterIsolator: false,
      NotConnectedToIgnition: false,
      iState: this.assetData.iState,
      Input1Name: null,
      Input1Mask: "",
      Input1Type: "",
      Input2Name: null,
      Input2Mask: "",
      Input2Type: "",

      //Other: null,
    }
  },
  computed: {
    ...mapGetters(['IS_ROOT', 'MajorToken', 'MinorToken']),
    assetTypeIcon(){
      return getAssetTypeIcon(this.AssetTypeCode)
    },
    isInput2Showed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Input2) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("IO,") >= 0
    },
    isInput1Showed(){
      let ret = false
      if(!this.ProductCode && !this.ProductList.length){
        return ret
      }

      let productObg = this.ProductList.find( (item) => item.Code === this.ProductCode )
      if(!productObg){
        return ret
      }

      let solutionObj = this.SolutionTypeList.find( (item) => item.Code === this.SolutionCode )
      if(!solutionObj){
        return ret
      }

      return (parseInt(productObg.Features) & ProductFeaturesEnum.Input1) > 0 &&
          solutionObj.Features && solutionObj.Features.indexOf("IO,") >= 0
    },
    input1Icon(){
      return getInputTypeIcon(this.Input1Name)
    },
    input2Icon(){
      return getInputTypeIcon(this.Input2Name)
    },
    input1NameLabel(){
      let ret = this.$t('Input1Name')
      if(this.Input1Type || this.Input1Mask){
        ret += ` (${ !this.Input1Type ? '' : this.Input1Type }, ${ !this.Input1Mask ? '' : this.Input1Mask + ' ' + this.$t('sec') })`
      }
      return ret
    },
    input2NameLabel(){
      let ret = this.$t('Input2Name')
      if(this.Input2Type || this.Input2Mask){
        ret += ` (${ !this.Input2Type ? '' : this.Input2Type }, ${ !this.Input2Mask ? '' : this.Input2Mask + ' ' + this.$t('sec') })`
      }
      return ret
    },

  },



  mounted() {
    //console.log(this.assetData)
    this.getSSP();
    this.getAssetInfo();
  },

  methods: {
    async onSubmit(){


      let $elFitmentOptions = $$(this.$refs.page.$el).find('[name="checkbox-fitmentoption"]')
      let fitmentOptionsVal = 0;
      $elFitmentOptions.forEach((el)=>{
        if(el.checked){
          fitmentOptionsVal += parseInt(el.value)
        }
      })

      let data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,
        ID: this.Id,
        IMEI: this.IMEI,
        SimNo: this.SimNo,
        ProductCode: this.ProductCode,
        AssetType: this.AssetTypeCode,
        PayPlanCode: this.ServicePlanCode,
        ActivateDate: !this.ActivateDate ? null : moment(this.ActivateDate[0]).format('DD/MM/YYYY'),
        WarrantyDate: !this.SuspendDate ? null : moment(this.SuspendDate[0]).format('DD/MM/YYYY'),
        Name: this.Name,
        IMEI2: this.AltIMEI,
        DESCRIBE1: this.Make,
        DESCRIBE2: this.Model,
        DESCRIBE3: this.Color,
        DESCRIBE4: this.Year,

        Solution: this.SolutionCode,
        FIELD_NVAR4: this.InstallLocation,
        _FIELD_DESCRIBE7: this.VinNumber,
        InitMileage: this.InitMileage,
        InitAccOnHours: this.InitRuntime,
        _FIELD_FLOAT4: this.FuelEconomy,
        INT2: fitmentOptionsVal,
        _FIELD_NVAR3: this.Registration,
        autoSuspend: this.AutoSuspend ? 1 : 0,
        CustomerCode: this.CustomerCode


        //_FIELD_DESCRIBE5: '',
        //INT8: '',
        //BeMonitored: '',
        //CustomerCode: '',
        //GroupCode: '',
      }
      if(this.isInput1Showed){
        data.Input1Name = this.Input1Name
      }
      if(this.isInput2Showed){
        data.Input2Name = this.Input2Name
      }

      this.isLoadingSave = true;
      let response = await QTAPI.AssetEdit(data)
      this.isLoadingSave = false;
      if (!response){
        return
      }
      this.$store.commit('ASSET_UPDATED')
      f7.notification.create({
        subtitle: this.$t('Success'),
        text: this.$t('DataUpdated'),
      }).open()
      this.f7router.back()
    },
    dateFormat(...options){
      return dateFormat(...options)
    },
    async getSSP(){
      this.isLoadingSSP = true;
      let ssp = await QTAPI.GetSSP({ DealerToken: this.MajorToken })
      this.isLoadingSSP = false;
      if(!ssp){
        return
      }
      this.ProductList = ssp.Products
      this.SolutionTypeList = ssp.Solutions
      this.ServicePlanList = ssp.ServiceProfiles
      let assetTypes = []
      if(ssp.AssetTypes && ssp.AssetTypes.length){
        ssp.AssetTypes.forEach((item)=>{
          assetTypes.push({
            code: item,
            name: item,
            icon: getAssetTypeIcon(item)
          })
        })
        assetTypes = SortArrayByObjProps(assetTypes, [{prop: 'name', direction: 1}])
      }
      this.AssetTypeList = assetTypes.length ? assetTypes : getAssetTypes()
      this.keyProductList++
      this.keyServicePlanList++
      this.keySolutionTypeList++
    },
    async getAssetInfo(){
      this.isLoading = true
      let result = await QTAPI.GetAssetInfo({majortoken: this.MajorToken, imeis: this.assetData.IMEI})
      this.isLoading = false
      if(!result){
        return
      }
      //console.log(result)
      this.ProductCode = result.ProductCode
      this.SolutionCode = result.Solution
      this.ServicePlanCode = result.ServicePlanCode
      this.Model = result.Model
      this.Make = result.Make
      this.Year = result.Year
      this.Color = result.Color
      this.Registration = result.Registration
      this.VinNumber = result.VinNumber
      this.InitMileage = result.InitMileage
      this.InitRuntime = result.InitAccHours
      this.InstallLocation = result.InstallLocation
      this.FuelEconomy = result.FuelEconomy
      this.Input1Name = result.Input1Name
      this.Input1Mask = result.Input1Mask
      this.Input1Type = result.Input1Type
      this.Input2Name = result.Input2Name
      this.Input2Mask = result.Input2Mask
      this.Input2Type = result.Input2Type
      this.CustomerCode = result.CsCode

      this.keyProductList++
      this.keyServicePlanList++
      this.keySolutionTypeList++

      if(result.FitmentOptions){
        result.FitmentOptions = parseInt(result.FitmentOptions)
        for (const option in FitmentOptionsEnum) {
          this[option] = (result.FitmentOptions & FitmentOptionsEnum[option]) > 0
        }
      }
    }
  },
}
</script>

<style scoped>

</style>